import { FC, PropsWithChildren } from 'react'
import { handleAxiosError, PlatformContextProvider } from 'react-common'
import { ProvideStencilContext } from '@/features/stencil/ProvideStencilContext/ProvideStencilContext'
import { isOpenCatalog } from '@/utils/isOpenCatalog'
import { isPublicCertificate } from '@/utils/isPublicCertificate'

type CustomNavigationContextProviderProps = PropsWithChildren<{}>
export const CustomNavigationContextProvider: FC<CustomNavigationContextProviderProps> = (props) => {
  const { children } = props

  const isPublicPage = isOpenCatalog() || isPublicCertificate()

  return (
    <ProvideStencilContext>
      <PlatformContextProvider appPrefix="learner" handleAxiosError={isPublicPage ? undefined : handleAxiosError()}>
        {children}
      </PlatformContextProvider>
    </ProvideStencilContext>
  )
}
